import React, { FC, memo } from 'react';
import styled from 'styled-components';
import { SectionTitle } from '../SummaryStyles';

const CommonText = styled.p`
  margin: 0.625rem 0;
`;

type Props = {
  text: string;
  title: string;
};

const SummaryCommon: FC<Props> = ({ text, title }) => {
  return (
    !!text && (
      <div>
        <SectionTitle>{title}</SectionTitle>
        <CommonText>{text}</CommonText>
      </div>
    )
  );
};

export default memo<Props>(SummaryCommon);
